module.exports = __webpack_public_path__ + "static/paragraph-1-mobile-709db2b695317ff759a8595be30450c1.svg";